export const loginUserKey = 'user';
export const userInfo = {
  username: "",
  id: null
};
export var userInfoDto = {
  username: "",
  id: null
};
export const sex = {
  male: {key: 0, value: '男'},
  female: {key: 0, value: '女'},
  wei_zhi: {key: 0, value: '未知'},
};
export const expireDefault = 1000 * 60 * 60;



// WEBPACK FOOTER //
// ./src/utils/Config.js